<div class="flex min-h-dvh flex-col bg-ground">
  <!--
    The header is pulled onto the hero rather than sitting above it: the hero
    section starts at the very top of the page and the header overlays its
    band. That is why the hero carries `pt-band-top`, the same 58px the app
    reserves above a band's first row.
  -->
  <div class="relative">
    <div class="absolute inset-x-0 top-0">
      <layout-header [onBand]="true" />
    </div>

    <main>
      <router-outlet></router-outlet>
    </main>
  </div>

  <layout-footer [withCta]="true" />

  <layout-language-suggestion />
</div>
